var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import UIModal from "@mui/joy/Modal";
import { useAppSelector } from "@/hooks/store";
import { Slot } from "@/utils/types/layout";
import WidgetDisplay from "@/components/widgets/widgetDisplay";
import { DialogContent, ModalClose, ModalDialog } from "@mui/joy";
import { useEffect, useMemo, useState } from "react";
import { WidgetTopic } from "@/utils/types/widgets";
import { useLayout } from "@/hooks/layout";
import { useEvents } from "@/hooks/events";
/**
 * Display app modal
 * @param param0
 * @returns
 */
function ModalDisplay(_a) {
    var widget = _a.widget, canClose = _a.canClose;
    var events = useEvents().eventBus;
    var layout = useLayout();
    var _b = useState(true), modalOpen = _b[0], setModalOpen = _b[1];
    //
    useEffect(function () {
        var topicId = "".concat(WidgetTopic.WIDGET_CLOSED, "/").concat(widget.id);
        var subscriptionId = events.on(topicId, function () {
            setModalOpen(false);
        });
        return function () {
            events.off(subscriptionId);
        };
    }, [events, widget]);
    return (_jsx(UIModal, __assign({ open: modalOpen, onClose: function (event, reason) {
            return events.trigger("".concat(WidgetTopic.WIDGET_REQUEST_CLOSE, "/").concat(widget.id), {
                widget: widget,
                reason: reason,
            });
        } }, { children: _jsxs(ModalDialog, { children: [_jsx(DialogContent, { children: _jsx(WidgetDisplay, { widget: widget, events: events }, widget.id) }), _jsx(ModalClose, {})] }) })));
}
export default function Modal() {
    var widgets = useAppSelector(function (state) { return state.layout.slots[Slot.MODAL].widgets; });
    var modalWidgets = useMemo(function () { return __spreadArray([], widgets, true).reverse(); }, [widgets]);
    return (_jsx(_Fragment, { children: modalWidgets &&
            modalWidgets.map(function (widget) { return (_jsx(ModalDisplay, { widget: widget }, widget.id)); }) }));
}
